import React from "react";
import "../styles/About.css"; // Banner styling
import "../styles/PrivacyPolicy.css"; // Custom styles

const Terms = () => {
  return (
    <>
      <section className="banner_area">
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay bg-parallax"></div>
          <div className="container">
            <div className="banner_content text-center">
              <h2>Terms & Conditions</h2>
              <div className="page_link">
                <a href="/">Home</a>
                <span className="breadcrumb-arrow">→</span>
                <a href="/terms">Terms & Conditions</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy_policy_area container py-5">
    <h3>Communication Consent</h3>
    <p>
      By providing your contact information and accepting communication via phone, email, WhatsApp, and SMS, you agree to receive details about programs, benefits, webinar invites, and other updates. Learnific will only use your data for education-related communication to support your learning decisions.
    </p>

    <h3>Academic Regulations</h3>
    <p>
      All courses at Learnific are governed by relevant academic regulations and may change over time. We may be required to share academic records with regulatory bodies if needed.
    </p>

    <h3>Application Fee</h3>
    <p>
      Course fees vary and are decided by our admissions team. Learnific reserves the right to revise fees as necessary.
    </p>

    <h3>Enrollment Policy</h3>
    <p>
      Enrolling in a course implies acceptance of Learnific’s rules and policies, including attendance, fee schedules, assessments, and conduct. Changes to rules may occur periodically.
    </p>

    <ul>
      <li>Failure to submit required documents can result in enrollment cancellation.</li>
      <li>Courses may be cancelled; if so, refunds will be issued if the cancellation is within one month of start.</li>
      <li>Non-payment within a 7-day grace period can result in admission cancellation without refund.</li>
      <li>75% minimum attendance is required for placement eligibility.</li>
      <li>Extended absences or repeated assessment failures may lead to dismissal without refund.</li>
      <li>Providing false information can result in removal without any refund.</li>
      <li>Course content is subject to academic review and may change.</li>
      <li>Content/material sharing is strictly prohibited and may result in legal action.</li>
      <li>Certificates may be withheld for unpaid dues. Placements are conditional.</li>
      <li>Consent is given for Learnific to use student names/achievements in promotions.</li>
      <li>Job offers may not be guaranteed and depend on course type and individual performance.</li>
    </ul>

    <h3>Property Damage and Other Charges</h3>
    <p>
      Students are liable for any damages caused. Failure to pay for damages can lead to deductions from fees or suspension.
    </p>
    <p>
      Additional charges may apply for fieldwork, materials, printing, or specialized needs. Students are responsible for these costs.
    </p>

    <h3>Personal Property</h3>
    <p>
      Learnific is not responsible for loss or damage to personal property or transmission of computer viruses.
    </p>

    <h3>Academic Dismissal</h3>
    <p>
      Learnific may remove students who fail to meet academic expectations or attendance requirements. Enrollment does not guarantee course completion or placement.
    </p>

    <h3>Legal Validity</h3>
    <p>
      If any clause is found to be unenforceable, the remaining terms will remain in effect.
    </p>

    <h3>Official Communication</h3>
    <p>
      Learnific may communicate by email, SMS, or post. Students are responsible for checking their LMS or communication channels regularly. Address updates must be submitted by students.
    </p>

    <h3>Confidentiality</h3>
    <p>
      All content, communication, and internal data from Learnific are proprietary. Students are prohibited from sharing or redistributing such information indefinitely.
    </p>

    <h3>Health & Wellbeing</h3>
    <ul>
      <li>Parents or students authorize Learnific to consent to emergency medical care, if needed.</li>
      <li>Students must disclose any known health issues before enrollment.</li>
      <li>Learnific may require medical fitness proof as deemed necessary.</li>
    </ul>

    <h3>Cancellation & Refund Policy</h3>
    <p>
      Learnific reserves the right to alter, cancel, or merge any course. Refunds for cancelled courses will follow internal policy.
    </p>
    <p>
      Students may request refunds only through authorized channels and in accordance with the terms communicated by their department.
    </p>

    <h3>User Responsibilities</h3>
    <p>
      Users are responsible for securing their account credentials. Unauthorized access must be reported immediately.
    </p>

    <h3>Arbitration Clause</h3>
    <p>
      Disputes will be resolved under the Arbitration and Conciliation Act, 1996, through an arbitrator appointed by Learnific in Mumbai, India. Criminal cases may proceed through regular legal channels.
    </p>
  </section>
    </>
  );
};

export default Terms;
